import React from 'react'
import { withQuiz } from 'components/Quiz'
import { withApp } from 'helpers'

class ExitEvent extends React.Component {
  componentDidMount() {
    this.props.app.toggleModal(null, 'logout')
  }

  render() {
    return null
  }
}

export default withApp(withQuiz(ExitEvent))


// WEBPACK FOOTER //
// ./src/components/events/ExitEvent.js